import { render, staticRenderFns } from "./SendSingleSms.vue?vue&type=template&id=72303156"
import script from "./SendSingleSms.vue?vue&type=script&lang=js"
export * from "./SendSingleSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports